// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"791":"ed314776","809":"92838ce7"}[chunkId] + ".css";
};